import Spinner from 'components/Spinner';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';

const LoadingScreen = () => {
    const { t } = useTranslation();
    return <div className={styles.wrapper}>
        <div className={styles.content}>
            <Spinner className={styles.spinner} />
            <div className={styles.text}>{t("common.loadingInProgress")}</div>
        </div>
    </div>
}

export default LoadingScreen;
